import { render, staticRenderFns } from "./CopyCdk.vue?vue&type=template&id=3cb9e658&scoped=true&"
import script from "./CopyCdk.vue?vue&type=script&lang=js&"
export * from "./CopyCdk.vue?vue&type=script&lang=js&"
import style0 from "./CopyCdk.vue?vue&type=style&index=0&id=3cb9e658&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9e658",
  null
  
)

export default component.exports